import React, { useState, useRef, useEffect } from "react";

// nodejs library to set properties for components
import PropTypes from "prop-types";
// nodejs library that concatenates classes
import classNames from "classnames";
import makeStyles from "@material-ui/core/styles/makeStyles";
import Editor from '@monaco-editor/react';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import Button from '@material-ui/core/Button';
import Icon from '@material-ui/core/Icon';
import Config from "../../config.js"

const CodeEditor = React.forwardRef((props, ref) => {
    const {
        uniqueId,
        size,
        languages,
        onClick,
        buttonEnable,
        ...rest
    } = props;
    useEffect(() => {
        if (uniqueId != uId) {
            setUId(uniqueId);
            if (languages && languages.length > 0)
                ChangeLanguage(languages[0])
        }
    });

    const [uId, setUId] = useState(null);

    const [language, setLanguage] = useState(null);
    const [isEditorReady, setIsEditorReady] = useState(false);
    const [sendEnable, setSendEnable] = useState(buttonEnable)

    const [code, setCode] = useState("//زبان را انتخاب کنید!");
    const valueGetter = useRef();
    useEffect(() => {
        setSendEnable(buttonEnable);
    }, [buttonEnable]);
    function handleEditorDidMount(_valueGetter) {
        setIsEditorReady(true);
        setSendEnable(true);
        valueGetter.current = _valueGetter;
    }
    function handleShowValue() {
        setSendEnable(false);
        onClick(valueGetter.current(), language);
    }
    function ChangeLanguage(langId) {
        if (!langId) return
        var result = Config.languages[langId]
        setLanguage(result)
        var code = result.sample;
        setCode(code)
    }
    const editor = {
        textAlign: 'left',
        direction: 'ltr',
        marginBottom: "50px"
    }
    const select = {
        textAlign: 'right',
        direction: 'rtl',
        marginBottom: "20px"
    }
    return (
        <div>
            <div style={select} >
                <p>زبان مورد نظر برای ارسال پاسخ:</p>
                <FormControl >
                    <Select disabled={!isEditorReady}
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={language && language.code}
                        onChange={(event) => ChangeLanguage(event.target.value)}
                    >
                        {languages && languages.map((langId, index) => {
                            var result = Config.languages[langId]
                            return (<MenuItem value={langId}>{result && result.title}</MenuItem>)
                        })}
                    </Select>
                    <FormHelperText>انتخاب زبان مورد نظر</FormHelperText>
                </FormControl>
            </div>
            <div style={editor} >
                <Editor
                    height={size}
                    theme={"dark"}
                    editorDidMount={handleEditorDidMount}
                    value={code}
                    language={language && language.value} />
                <br />
                <p>
                    <Button
                        variant="contained"
                        color="primary"
                        disabled={!sendEnable}
                        onClick={handleShowValue}
                    >
                        ارسال کد
      </Button>
                </p>
            </div>
        </div>
    );
});


export default CodeEditor;
